import { useLang } from '../../../i18n/LangContext';

export default function Experience() {
  const { t } = useLang();

  const experiences = [
    {
      periodKey: 'exp1_period',
      companyKey: 'exp1_company',
      positionKey: 'exp1_position',
      descKey: 'exp1_desc',
      achievements: ['exp1_a1', 'exp1_a2', 'exp1_a3'],
    },
    {
      periodKey: 'exp2_period',
      companyKey: 'exp2_company',
      positionKey: 'exp2_position',
      descKey: 'exp2_desc',
      achievements: ['exp2_a1', 'exp2_a2', 'exp2_a3'],
    },
  ];

  return (
    <section id="experience" className="relative py-24 px-6 bg-gradient-to-b from-transparent to-[#0a0e1a]/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent">
            {t('exp_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] mx-auto"></div>
        </div>

        <div className="space-y-8">
          {experiences.map((exp, index) => (
            <div key={index} className="bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] p-8 rounded-2xl border border-[#d4af37]/20 hover:border-[#d4af37]/50 transition-all duration-300 hover:shadow-xl hover:shadow-[#d4af37]/10">
              <div className="flex flex-col md:flex-row md:items-start gap-6">
                <div className="md:w-48 flex-shrink-0">
                  <div className="inline-block px-4 py-2 bg-[#d4af37]/10 rounded-lg border border-[#d4af37]/30">
                    <div className="text-[#d4af37] font-semibold">{t(exp.periodKey)}</div>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#d4af37] mb-2">{t(exp.positionKey)}</h3>
                  <h4 className="text-xl text-gray-300 mb-4">{t(exp.companyKey)}</h4>
                  <p className="text-gray-400 mb-6 leading-relaxed">{t(exp.descKey)}</p>
                  <div className="space-y-3">
                    <div className="text-sm font-semibold text-[#d4af37] mb-2">{t('exp_key')}</div>
                    {exp.achievements.map((key, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-[#d4af37]"></i>
                        </div>
                        <p className="text-gray-300">{t(key)}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: 'ri-trophy-line',        labelKey: 'stat_certs',    val: '15+' },
            { icon: 'ri-briefcase-line',      labelKey: 'stat_projects', val: '200+' },
            { icon: 'ri-team-line',           labelKey: 'stat_clients',  val: '500+' },
            { icon: 'ri-bar-chart-box-line',  labelKey: 'stat_roi',      val: '+28%' },
          ].map((s, i) => (
            <div key={i} className="text-center p-6 bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] rounded-xl border border-[#d4af37]/20">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                <i className={`${s.icon} text-3xl text-[#d4af37]`}></i>
              </div>
              <div className="text-sm text-gray-400">{t(s.labelKey)}</div>
              <div className="text-2xl font-bold text-[#d4af37]">{s.val}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
